import React, { useState } from 'react'
import OutsideClickHandler from 'react-outside-click-handler'
import { getTargetForLink } from '../../../../utility/get-target-for-link'
import { useResources } from '../../../../utility/use-resources'
import { Backdrop, StyledPoster } from '../../styled'
import { StyledMobileBackButton, StyledMobileMenu, StyledMobileMenuItem, StyledMobileMenuLink, StyledMobileMenuPosterList, StyledMobileSubMenuPanel } from './styled'
import { useVisibleMenuItemsContext } from '../useVisibleMenuItems'

export const MobileMenu = props => {
  const { visibleMenuItems, loaded } = useVisibleMenuItemsContext()
  const [firstLevelSelected, setFirstLevelSelected] = useState(null)
  const [r] = useResources("new-menu", "canaryMenu");

  // if no items are visible, return an empty div with spacing 
  if (visibleMenuItems.length !== 0 || !loaded) return <div style={{ width: '15px', flexShrink: 0 }} />

  return (
    <Backdrop $open={props.isOpen} $top={70}>
      <OutsideClickHandler onOutsideClick={() => props.setIsOpen(null)}>
        <div className="menu-trigger">
          <button onClick={() => props.setIsOpen(state => !state)}>
            <i />
          </button>
        </div>
          <StyledMobileMenu $open={props.isOpen}>
            {r().map(menuItem => (
              <>
                {menuItem.href ? (
                  <StyledMobileMenuLink data-theme={menuItem.theme ?? 'default'} to={menuItem.href}>
                    {menuItem.name}
                    {menuItem.afterText && <span>{menuItem.afterText}</span>}
                  </StyledMobileMenuLink>
                ) : (
                  <StyledMobileMenuItem data-theme={menuItem.theme ?? 'default'} onClick={() => setFirstLevelSelected(menuItem.name)}>
                    {menuItem.name}
                    {menuItem.afterText && <span>{menuItem.afterText}</span>}
                  </StyledMobileMenuItem>
                )}
                {menuItem.links && menuItem.links.length > 0 && (
                  <StyledMobileSubMenuPanel $open={firstLevelSelected === menuItem.name}>
                    <StyledMobileBackButton onClick={() => setFirstLevelSelected(null)}>Back</StyledMobileBackButton>
                    <ul>
                      {menuItem.links.map(secondLevelLink => (
                        <li key={secondLevelLink.name}>
                          <StyledMobileMenuLink tabindex={-1} to={secondLevelLink.href}>
                            {secondLevelLink.name}
                          </StyledMobileMenuLink>
                        </li>
                      ))}
                    </ul>
                    <StyledMobileMenuPosterList>
                      {menuItem.posters.map(poster => (
                        <li key={poster.href}>
                          <StyledPoster to={poster.href} key={poster.href} target={getTargetForLink(poster.href)}>
                            <img src={poster.image.downloadURL} alt={poster.image.ref} />
                            <p className="link-secondary">{poster.name}</p>
                          </StyledPoster>
                        </li>
                      ))}
                    
                    </StyledMobileMenuPosterList>
                  </StyledMobileSubMenuPanel>
                )}
              </>
            ))}
          </StyledMobileMenu>
      </OutsideClickHandler>
    </Backdrop>
  )
}